module.exports = __webpack_public_path__ + "media/components/assets/img/icons/loader-negative-80d553efd0b0c0a3d813b352287aa9bf.svg";